module.exports = __webpack_public_path__ + "img/图片26.f31d5c2e.png";